import React from 'react';

export const StickyComponentContext = React.createContext();
